module.exports = __webpack_public_path__ + "img/fig2.b6ffc70b.png";